<div [ngClass]="getClassNames()" role="img" [attr.aria-label]="name">
  <img *ngIf="img" [attr.src]="img" alt="{{ name }} profile photo" role="presentation" />
  <span role="presentation" *ngIf="!img">{{ initials }}</span>
</div>
